import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Header, adminTheme } from "@sequentech/ui-essentials";
import { useContext, useEffect, useState } from "react";
import { AppBar, useGetOne } from "react-admin";
import { AuthContext } from "../providers/AuthContextProvider";
import { getValueFromCookie, setCookie, USER_LANGUAGE_COOKIE_NAME, } from "@sequentech/ui-core";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { TenantContext } from "@/providers/TenantContextProvider";
import SequentLogo from "@sequentech/ui-essentials/public/Sequent_logo.svg";
import BlankLogoImg from "@sequentech/ui-essentials/public/blank_logo.svg";
export var CustomAppBar = function () {
    var _a, _b, _c, _d, _e;
    var authContext = useContext(AuthContext);
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _f = useContext(TenantContext), tenantId = _f.tenantId, tenant = _f.tenant, setTenant = _f.setTenant;
    var tenantData = useGetOne("sequent_backend_tenant", {
        id: tenantId,
    }).data;
    var _g = useState(true), isFetching = _g[0], setIsFetching = _g[1];
    useEffect(function () {
        if (tenantData) {
            setTenant(tenantData);
            setIsFetching(false);
        }
    }, [tenantData]);
    var langList = (_c = (_b = (_a = tenant === null || tenant === void 0 ? void 0 : tenant.settings) === null || _a === void 0 ? void 0 : _a.language_conf) === null || _b === void 0 ? void 0 : _b.enabled_language_codes) !== null && _c !== void 0 ? _c : ["en"];
    var _h = useState((_d = tenant === null || tenant === void 0 ? void 0 : tenant.annotations) === null || _d === void 0 ? void 0 : _d.logo_url), logoUrl = _h[0], setLogoUrl = _h[1];
    var _j = useState(BlankLogoImg), logoImg = _j[0], setLogoImg = _j[1];
    useEffect(function () {
        setLogoImg(logoUrl !== null && logoUrl !== void 0 ? logoUrl : BlankLogoImg);
    }, []);
    /*  When tenant annotations column is empty annotations.logo_url will be
        undefined and in that case Sequent logo must be shown.
        But while data isn't fetched yet annotations.logo_url is also undefined
        and a blank logo must be shown.
    */
    useEffect(function () {
        var _a;
        var newLogoState = (_a = tenant === null || tenant === void 0 ? void 0 : tenant.annotations) === null || _a === void 0 ? void 0 : _a.logo_url;
        setLogoUrl(newLogoState);
        if (!isFetching) {
            setLogoImg(newLogoState !== null && newLogoState !== void 0 ? newLogoState : SequentLogo);
        }
    }, [(_e = tenant === null || tenant === void 0 ? void 0 : tenant.annotations) === null || _e === void 0 ? void 0 : _e.logo_url, logoUrl, isFetching]);
    var onChangeLanguage = function (lang) {
        if (getValueFromCookie(USER_LANGUAGE_COOKIE_NAME) !== lang) {
            setCookie(USER_LANGUAGE_COOKIE_NAME, lang);
        }
    };
    return (_jsx(AppBar, { toolbar: _jsx(_Fragment, {}), position: "static", sx: {
            "backgroundColor": adminTheme.palette.lightBackground,
            "color": "black",
            "& .MuiContainer-root.MuiContainer-maxWidthLg": {
                maxWidth: "unset",
            },
            "boxShadow": "unset",
        }, children: _jsx(Header, { appVersion: { main: globalSettings.APP_VERSION }, appHash: { main: globalSettings.APP_HASH }, userProfile: {
                firstName: authContext.firstName,
                username: authContext.username,
                email: authContext.email,
                openLink: authContext.openProfileLink,
            }, logoutFn: authContext.isAuthenticated ? authContext.logout : undefined, languagesList: langList, logoUrl: logoImg, onChangeLanguage: onChangeLanguage }) }));
};
